import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForUserVisible } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import parameters from './__generated__/CsmAppSidebarContentQuery$parameters';
import type { CsmAppSidebarContentQuery } from './__generated__/CsmAppSidebarContentQuery.graphql';
import type { CsmAppSidebarEntryPointParams } from './csmAppSidebarEntryPoint.entrypoint.types.tsx';

type Queries = { csmAppSidebarQuery: CsmAppSidebarContentQuery };

type CsmAppSidebarEntryPointComponent = EntryPointComponent<Queries, {}, {}, {}>;

export const csmAppSidebarEntryPoint: EntryPoint<
	CsmAppSidebarEntryPointComponent,
	CsmAppSidebarEntryPointParams
> = createEntryPoint({
	root: JSResourceForUserVisible<CsmAppSidebarEntryPointComponent>(
		/* webpackChunkName: "csm-app-sidebar-entry-point" */ './CsmAppSidebar.tsx',
		{ includeInShellOnlySsrBundle: true, entryFsSsrLiftImportToModule: true },
	),
	getPreloadProps: ({
		tenantContext: { cloudId },
		isProjectsExpanded,
	}: CsmAppSidebarEntryPointParams) => ({
		queries: {
			csmAppSidebarQuery: {
				parameters,
				variables: {
					cloudId,
					isProjectsExpanded,
				},
				options: { fetchPolicy: 'store-and-network' as const },
			},
		},
	}),
});
